import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../../Context';
import Flex from '@wix/da-ds/pkg/Flex';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import FluidMargin from '../FluidMargin';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation } from '../../../../DeviationViews/_helpers';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import desktopActionBarStyles from '../DesktopActionBar.scss';
export const SecondaryDesktopActionBar = ({ deviation, isOwner })=>{
    const { isTheater } = useDeviationViewContext();
    const { isCommentable, isFavouritable, isGroupSubmittable, hasMoreActions } = useDeviationAttributes(deviation, isOwner);
    const isTextual = isTextualDeviation(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: classnames(desktopActionBarStyles['root'], isTheater ? desktopActionBarStyles['theater'] : desktopActionBarStyles['normal-view'], isOwner && desktopActionBarStyles['owner'], isTextual && desktopActionBarStyles['literature'], desktopActionBarStyles['secondary'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['badge']
    }), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 1
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-middle']
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, isFavouritable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "secondary"
    })), isCommentable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner,
        actionBarType: "secondary"
    }))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 4
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, isGroupSubmittable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation,
        actionBarType: "secondary"
    })), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 2
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    })), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 3
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-right']
    })));
};
SecondaryDesktopActionBar.displayName = 'SecondaryDesktopActionBar';
export default SecondaryDesktopActionBar;
